import { render, staticRenderFns } from "./CurrentCoach.vue?vue&type=template&id=68e2ed38&scoped=true"
import script from "./CurrentCoach.vue?vue&type=script&lang=js"
export * from "./CurrentCoach.vue?vue&type=script&lang=js"
import style0 from "./CurrentCoach.vue?vue&type=style&index=0&id=68e2ed38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e2ed38",
  null
  
)

export default component.exports